import { getFormDefinition, createFormDataFromItem, createItemFromFormData } from './form';
import { entityToStore } from '@/utils/store';
import baseCrudMixin from '@/mixins/crud';
export default {
  computed: {
    definition() {
      return this.createDefinition();
    },
    entityStore() {
      return entityToStore(this.entity);
    }
  },
  mixins: [baseCrudMixin],
  data: () => ({
    entity: 'Store',
    returnTo: 'Clients'
  }),
  created() {
    const params = {
      query: {
        domainID: this.$route.params.domainID
      }
    };
    this.$store.dispatch('country/getItems');
    this.$store.dispatch('storeAttribute/getItems', params);
    this.$store.dispatch('storeType/getItems', params);
  },
  methods: {
    createDefinition() {
      return getFormDefinition(this);
    },
    createFormDataFromItem,
    createItemFromFormData
  }
};
